import { CreateClaimantState } from '../types/createClaimantSliceTypes';

const initialCreateClaimantSteps = {
  relationshipInfo: {
    relationshipId: null,
    relationshipName: '',
    relationshipType: '',
  },
  businessDetails: {
    businessName: '',
    representativeFirstName: '',
    representativeLastName: '',
    tin: '',
    documentsDeliveryPreference: '',
    documentsDeliveryPreferenceId: null,
    stateOfResidence: '',
    stateOfResidenceId: null,
    allocation: null,
    contingent: null,
  },
  personDetails: {
    firstName: '',
    middleName: '',
    lastName: '',
    prefix: '',
    prefixId: null,
    suffix: '',
    gender: '',
    genderId: null,
    ssn: '',
    clientId: '',
    dateOfBirth: null,
    dateOfDeath: null,
    documentsDeliveryPreference: '',
    documentsDeliveryPreferenceId: null,
    stateOfResidence: '',
    stateOfResidenceId: null,
    maritalStatus: '',
    maritalStatusId: null,
    occupation: '',
    occupationId: null,
    allocation: null,
    contingent: null,
  },
  addressInfo: {
    isPaymentAddress: false,
    isResidenceAddress: false,
    isMailingAddress: false,
    reAttn: '',
    streetAddress: '',
    addressDetails: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
  },
  contactInfo: {
    contactPreference: '',
    contactPreferenceId: null,
    mobileNumber: '',
    landline: '',
    email: '',
    fax: '',
  },
  paymentInfo: [],
};

export const createClaimantInitialState: CreateClaimantState = {
  createClaimantType: 'auto',
  createClaimantSteps: initialCreateClaimantSteps,
  userForClaimantCreate: null,
  statuses: {
    isCreateClaimantLoading: false,
  },
};
